<style lang="scss" scoped>
.app-page {
  height: 100%;
}

// 投稿成功 弹框
::v-deep() {
  .success-dialog {
    .el-dialog {
      border-radius: 12px;
    }

    .el-dialog__header .el-dialog__title {
      display: none;
    }

    .el-dialog__headerbtn .el-dialog__close {
      font-size: 24px;
      color: #191919;

      &:hover {
        color: #B7251E;
      }
    }

    .d1,
    .d2 {
      color: #1a1a1a;
    }
  }
}

.consulting-box {
  position: fixed;
  right: 0;
  bottom: 40vh;
  z-index: 66666666;
  padding-right: 20px;

  .iconfont {
    display: block;
    width: 20px;
    height: 20px;
    background: #DDDDDD;
    border-radius: 50%;
    color: #ffffff;
    line-height: 20px;
    text-align: center;
    position: absolute;
    right: 0;
    bottom: 72px;
    transition: all 0.36s;
    

    &:hover {
      background: #B7251E;
    }

    cursor: pointer;
    font-size: 12px;
    font-weight: 600;


  }

  .tip {
    padding: 10px 20px;
    border-radius: 10px;
    line-height: 24px;
    max-width: 200px;
    background: #E6ECF6;
    color: #333;
    position: relative;
    margin-bottom: 8px;

    &::after {
      content: "";
      display: block;
      width: 10px;
      height: 10px;
      background: #E6ECF6;
      transform: rotate(45deg);
      position: absolute;
      bottom: -5px;
      right: 30px;

    }
  }
}

.consulting-img {
  cursor: pointer;
}

.consulting-iframe {
  position: fixed;
  right: 0;
  top: 0;
  height: 100vh;
  width: 415px;
  background: #ffffff;
  z-index: 9999999999999999;

  &:hover{
    .iconfont{
      opacity: 1;
    }
  }

  .iconfont {
    position: absolute;
    right: 6px;
    top: 6px;
    font-size: 20px;
    cursor: pointer;
    opacity: 0;
    transition: all 0.36s;

    &:hover {
      color: #B7251E;
    }
  }
}
</style>
<template>
  <section class="app-page">


    <!-- 小海 -->
    <!-- <div class="consulting-box df fdc aife">
      <div class="tip" v-show="consultingFlog">
        {{ $t('Hi! 我是存储智能小海,欢迎向我提问!') }}
      </div>
      <img src="@/assets/images/greetings-img.gif" style="width: 80px;" class="consulting-img" @click="handleConsulting"
        alt="">

      <span class="iconfont" :class="consultingFlog ? 'icon-jian' : 'icon-jia1'"
        @click="consultingFlog = !consultingFlog">
      </span>
    </div> -->


    <!-- 只能存储问答 -->

    <!--<div class="consulting-iframe" v-if="Showconsulting">
      <span class="iconfont icon-cuo" @click="Showconsulting = false"></span>
      <iframe src="https://info.support.huawei.com/storageinfo/sme-robot/#/home?channel=true" style="width: 100%;height: 100%;" frameborder="0"></iframe>
    </div>-->


    <!-- 头部 -->
    <navbar v-if="!route_query.is_admin" />
    <!-- 主体部分 -->

    <app-main />

    <!-- 尾部 -->
    <footer-page v-if="showFooter && !route_query.is_admin" />

    <!-- 发布文章 -->
    <articleModel ref="articleDialog" :tt_id="thumbsId" :classData="tablist" :articleScore="article_score"
      @post-submitted="handlePostSubmitted" />

    <!-- 发布帖子 -->
    <postModel ref="postDialog" :data="data_list" @post-submitted="handlePostModelSubmitted" />

    <ebookApplyModel ref="ebookDialog" @ebook-submitted="handleEbookSubmitted" :data="data_list" />
    <!-- 投稿成功 -->
    <el-dialog title="" width="500px" top="10vh" :visible.sync="isVisible" @close="isVisible = false"
      :close-on-click-modal="false" class="success-dialog">
      <div class="df jcc">
        <img src="@/assets/images/journal-nodata.png" class="ml-20" alt="">
      </div>
      <div class="d1 mic-semblod ta-c fs-18 lh-26">
        {{ $t('投稿成功') }}
      </div>
      <div class="d2 fs-14 lh-22 mt-16">
        <p>{{ $t('感谢您的精彩投稿！✨我们的编辑团队正在快马加鞭审核中，请稍候~') }}</p>
        <p>{{ $t('如有任何修改建议，会第一时间与您联系沟通哒！') }}</p>
      </div>
    </el-dialog>
  </section>

</template>

<script>
import { addEbookApply } from "@api/ebook";
// import { mapGetters, mapActions } from 'vuex';
import AppMain from "./components/AppMain";
import Navbar from "./components/Navbar";
import FooterPage from "./components/FooterPage";

// 发布帖子弹框
import postModel from "@/components/postModel.vue";
// 文章投稿
import articleModel from "@/components/articleModel.vue";

// 我要投稿
import ebookApplyModel from "../journal/ebookApplyModel.vue";

import { gettopicList, getcommonData, getMyInfo } from "@api/home";

import { setArticleAdd } from "@api/active";

import { addApipost } from "@api/home";

export default {
  name: "Layout",
  components: {
    AppMain,
    Navbar,
    FooterPage,
    articleModel,
    ebookApplyModel,
    postModel,
  },
  computed: {
    // ...mapGetters() // 使用命名空间访问 home 模块的 datalist getter
    // ...mapState('home', ['datalist'])
  },

  data() {
    return {
      // 文章
      thumbsId: "",
      tablist: [],
      article_score: [],

      data_list: {},

      showFooter: true,
      route_query: {}, // 路由更多参数（后台iframe预览）
      isVisible: false,

      // 小海
      consultingFlog: true,

      Showconsulting: false,

      // 用户信息

      userinfo: {},

    };
  },
  created() {
    this.route_query = { ...this.$route.query }; // 路由更多参数（后台iframe预览）
    // 在页面创建时，根据需要决定是否显示footer
    this.showFooter = this.shouldShowFooter();
  },
  async mounted() {


    let resuserinfo = await getMyInfo();
    if (resuserinfo.status == 200) {
      this.userinfo = resuserinfo.data;
      // 获取登录的用户信息
      if (this.userinfo) {
        localStorage.setItem('userinfo', JSON.stringify(this.userinfo));
      }
      if (this.userinfo == null) {
        this.userinfo = [];
      }
    }


    // 设置默认的文章类型  --  默认选择第一个

    let res = await gettopicList();
    if (res.status == 200) {
      this.tablist = res.data.topic_list.map((item) => {
        return { tt_title: item.tt_title, tt_id: item.tt_id };
      });
      localStorage.setItem("topicList", JSON.stringify(this.tablist));
      if (this.tablist.length > 0) {
        this.thumbsId = this.tablist[0].tt_id;
      }
    }

    this.$bus.$on("openModalflog", (data) => {
      if (data == 1) {
        this.getarticle();
      } else if (data == 2) {
        this.getPost();
      } else if (data == 3) {
        this.openModalflog();
      } else {
      }
    });
  },

  methods: {

    // 
    // 小海咨询
    handleConsulting() {
      if (!this.userinfo || this.userinfo.length == 0) {
        const callback = window.location.href;
        this.$navigate('/login?callback=' + callback, null, false);
        return;
      }
      this.Showconsulting = !this.Showconsulting;
    },


    async handleEbookSubmitted(content) {
      let res = await addEbookApply(content);
      if (res.status == 200) {
        //this.$message.success(res.msg);
        this.isVisible = true;
      }
    },

    // 打开我要投稿
    async openModalflog(data) {
      let data_list = localStorage.getItem("datalist");
      if (data_list) {
        this.data_list = JSON.parse(data_list);
      } else {
        let res = await getcommonData();
        if (res.status == 200) {
          this.data_list = res.data;
        }
      }
      this.$refs.ebookDialog.openModal();
    },
    shouldShowFooter() {
      // 这里可以根据路由或其他条件判断是否需要显示footer
      // 例如，通过路由的meta字段来控制
      return !this.$route.meta.hideFooter;
    },

    async getPost() {
      let res = await getcommonData();
      if (res.status == 200) {
        this.data_list = res.data;
      }
      this.$refs.postDialog.openModal();
    },

    // 获取文章类型数据
    async getarticle() {
      let res = await gettopicList();
      if (res.status == 200) {
        this.tablist = res.data.topic_list.map((item) => {
          return { tt_title: item.tt_title, tt_id: item.tt_id };
        });
        if (this.tablist.length > 0) {
          this.thumbsId = this.tablist[0].tt_id;
        }
        let article_score = localStorage.getItem('datalist');
        if (article_score) {
          this.article_score = JSON.parse(article_score).article_source_list;
        } else {
          let res = await getcommonData();
          if (res.status == 200) {
            this.article_score = res.data.article_source_list;
            localStorage.setItem('datalist', JSON.stringify(res.data));
          }
        }
      }
      this.$refs.articleDialog.openModal();
    },

    // 发文章
    async handlePostSubmitted(content) {
      let res = await setArticleAdd(content);
      if (res.status == 200) {
        this.$message.success(res.msg);
      }
    },

    // 发布帖子

    async handlePostModelSubmitted(content) {
      let res = await addApipost(content);
      if (res.status == 200) {
        this.$message.success(res.msg);
      }
    },
  },
};
</script>
